var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    { attrs: { "no-margin": "" } },
    [
      _c(
        "w-col",
        { attrs: { xs: "12", md: "6", xl: "4" } },
        [
          _c("w-input", {
            attrs: { fancy: "", label: "nl-be" },
            model: {
              value: _vm.value.nlBe,
              callback: function ($$v) {
                _vm.$set(_vm.value, "nlBe", $$v)
              },
              expression: "value.nlBe",
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12", md: "6", xl: "4" } },
        [
          _c("w-input", {
            attrs: { fancy: "", label: "en" },
            model: {
              value: _vm.value.en,
              callback: function ($$v) {
                _vm.$set(_vm.value, "en", $$v)
              },
              expression: "value.en",
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12", md: "6", xl: "4" } },
        [
          _c("w-input", {
            attrs: { fancy: "", label: "fr" },
            model: {
              value: _vm.value.fr,
              callback: function ($$v) {
                _vm.$set(_vm.value, "fr", $$v)
              },
              expression: "value.fr",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }